import { getTestAttributes, slug } from '@chillibean/component-library';
import PropTypes from 'prop-types';
import styled from 'styled-components';

function AssetInformation(props) {
  const { infoFields } = props;

  return (
    <Container {...getTestAttributes('asset-information')}>
      {Object.keys(infoFields).map((infoField) => (
        <InfoField key={slug(infoField)} {...getTestAttributes('asset-information-info-field')}>
          <Title {...getTestAttributes(`${slug(infoField)}-info-field-title`)}>{infoField}</Title>
          <Value {...getTestAttributes(`${slug(infoField)}-info-field-value`)}>{infoFields[infoField]}</Value>
        </InfoField>
      ))}
    </Container>
  );
}
const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
  width: 100%;
  height: fit-content;
  padding: 30px 20px;
  overflow: scroll;
`;

const InfoField = styled.div`
  display: flex;
  flex-direction: column;
  &:not(:last-child) {
    padding-bottom: 20px;
  }
`;

const Title = styled.div`
  font-size: 10px;
  color: #999999;
`;

const Value = styled.div`
  font-size: 13px;
  color: #63666a;
`;

AssetInformation.propTypes = {
  infoFields: PropTypes.shape({}).isRequired,
};

export default AssetInformation;
